import { Controller } from '@hotwired/stimulus'
import { confirming } from '../lib/alert_modal'

export default class extends Controller {
  static values = {
    message: String,
    ok: String,
    cancel: String,
    skip: { type: Boolean, default: false },
  }

  connect = () => {
    this.element.addEventListener(this.submitMethod, this.confirm)
  }

  confirm = (event) => {
    if (!this.skipValue) {
      event.preventDefault()
      event.stopImmediatePropagation()

      confirming(...this.args).then((result) => {
        if (result) {
          this.skipValue = true
          return event.target[this.submitMethod]()
        }
      })
    }
  }

  get args() {
    const argsArray = [
      this.messageValue || 'Are you sure?',
      this.okValue || 'OK',
      this.cancelValue || 'Cancel',
    ]

    return argsArray
  }

  get isForm() {
    return this.element.nodeName === 'FORM'
  }

  get submitMethod() {
    return this.isForm ? 'submit' : 'click'
  }
}
